import request from '@/utils/request'

let MessageApi = {
  /*会员模板列表*/
  messageList(data) {
    return request._post('/shop/setting.message/index', data);
  },
  /*会员模板字段列表*/
  fieldList(data) {
    return request._post('/shop/setting.message/field', data);
  },
  /*会员模板字段设置保存*/
  saveSettings(data) {
    return request._post('/shop/setting.message/saveSettings', data);
  },
  /*会员模板设置状态修改*/
  updateSettingsStatus(data) {
    return request._post('/shop/setting.message/updateSettingsStatus', data);
  },
}

export default MessageApi;



// WEBPACK FOOTER //
// ./src/api/message.js